<h2>{{ page_title }}</h2>
<p class="subtitle">Un momento, estamos verificando tu acceso…</p>

<div class="oauth-loading">
  <mat-spinner diameter="40"></mat-spinner>
</div>
